import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
  &: first-child {
    margin-left: 0;
  }
`;

const Title = styled.span`
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: bold;
`;

const DigitContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0;
`;

const SingleDigit = styled.span<{ color: string }>`
  position: relative;
  display: flex;
  flex: 0 1 25%;
  font-size: 25px !important;
  background-color: ${props => props.color};
  border-radius: 5px;
  padding: 10px 12px;
  color: white;
  &:first-child {
    margin-right: 2px;
  }
`;

export default function Digit({ value, title }) {
  const leftDigit = value >= 10 ? value.toString()[0] : '0';
  const rightDigit = value >= 10 ? value.toString()[1] : value.toString();
  const { firstColor } = useContext(ThemeContext)

  return (
    <Container>
      <Title>{title}</Title>
      <DigitContainer>
        <SingleDigit color={firstColor}>
          {leftDigit}
        </SingleDigit>
        <SingleDigit color={firstColor}>
          {rightDigit}
        </SingleDigit>
      </DigitContainer>
    </Container>
  );
}